__turbopack_context__.v({
  "className": "helveticanow_2b64ae29-module__FKEc4G__className",
});
